import { render, staticRenderFns } from "./ItemStep.vue?vue&type=template&id=54f6f7cc&scoped=true&"
import script from "./ItemStep.vue?vue&type=script&lang=js&"
export * from "./ItemStep.vue?vue&type=script&lang=js&"
import style0 from "./ItemStep.vue?vue&type=style&index=0&id=54f6f7cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f6f7cc",
  null
  
)

export default component.exports